import {Breadcrumbs, DataTable} from '@management-ui/core';
import {Paper} from '@mui/material';
import {reverse} from 'named-urls';
import * as React from 'react';
import {useCallback, useContext, useMemo} from 'react';
import {useHistory} from 'react-router-dom';
import {ServiceContext} from '../../../components/Services';
import routes from '../../../routes';
import TrustForm from '../forms/TrustForm';

const Trusts = () => {
  const services = useContext(ServiceContext);
  const history = useHistory();

  const goToDetail = useCallback((trust) => {
    history.push(reverse(routes.trusts.detail, {id: trust.id}));
  }, [history]);

  return (
    <div>
      <Breadcrumbs crumbs={[{title: 'Trusts'}]}/>
      <Paper>
        <DataTable
          title="Trusts"
          columns={useMemo(() => [
            {title: 'Name', field: 'name'}
          ], [])}
          loadData={query => new Promise((resolve, reject) => {
            services.trust.getTableTrusts(query)
              .then(response => {
                resolve({
                  data: response.data, page: response.meta.current_page - 1, totalCount: response.meta.total
                });
              }).catch(() => reject());
          })}
          newForm={{
            title: 'Link New Trust',
            render: (props) => <TrustForm trust={{}} {...props}/>,
            onSaved: goToDetail
          }}
          onRowClick={goToDetail}
        />
      </Paper>
    </div>
  );
};

export default Trusts;
